<div class="initials" data-qa="test-initials">{{ initials }}</div>
